import { render, staticRenderFns } from "./GifViewer.vue?vue&type=template&id=70f7dcfe&scoped=true&"
import script from "./GifViewer.vue?vue&type=script&lang=js&"
export * from "./GifViewer.vue?vue&type=script&lang=js&"
import style0 from "./GifViewer.vue?vue&type=style&index=0&id=70f7dcfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f7dcfe",
  null
  
)

export default component.exports